import React from "react";

import { StyledListHeaderItem, StyledListHeaderItemProps } from "./styled";

export type ListHeaderItemProps = StyledListHeaderItemProps;

export const ListHeaderItem: React.FC<ListHeaderItemProps> = ({
  children,
  width,
}) => {
  return <StyledListHeaderItem width={width}>{children}</StyledListHeaderItem>;
};
